import { MessageBox, Loading } from "element-ui";
import { Toast } from "vant";

function localData(t, key, data) {
	let localStorage = window.localStorage;
	if (t == "set") {
		// 保存
		localStorage.setItem(key, data || "");
	} else if (t == "get") {
		// 读取
		return localStorage.getItem(key) || "";
	} else if (t == "remove") {
		// 删除某个值
		localStorage.removeItem(key);
	} else if (t == "clear") {
		localStorage.clear();
	}
}

function sessionData(t, key, data) {
	let sessionStorage = window.sessionStorage;
	if (t == "set") {
		// 保存
		sessionStorage.setItem(key, data || "");
	} else if (t == "get") {
		// 读取
		return sessionStorage.getItem(key) || "";
	} else if (t == "remove") {
		// 删除某个值
		sessionStorage.removeItem(key);
	} else if (t == "clear") {
		sessionStorage.clear();
	}
}

function cookieData(t, key, data) {
	if (t == "set") {
		// 保存
		let exp = new Date();
		exp.setTime(exp.getTime() + 30 * 24 * 60 * 60 * 1000); // 存一个月
		// document.cookie = key+'='+escape(data||'')+';expires='+exp.toGMTString();
		document.cookie =
			key +
			"=" +
			escape(data || "") +
			";path=/;expires=" +
			exp.toGMTString();
	} else if (t == "get") {
		// 读取
		let arr,
			reg = new RegExp("(^| )" + key + "=([^;]*)(;|$)");
		if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
		else return null;
	} else if (t == "remove") {
		// 删除某个值
		var exp = new Date();
		exp.setTime(exp.getTime() - 1);
		var cval = cookieData("get", key);
		if (cval != null)
			document.cookie =
				key + "=" + cval + ";expires=" + exp.toGMTString();
	}
}

function getUrlParam(name) {
	let url = document.location.toString();
	let arrObj = url.split("?");
	if (arrObj.length > 1) {
		let arrPara = arrObj[1].split("&");
		let arr;

		for (let i = 0; i < arrPara.length; i++) {
			arr = arrPara[i].split("=");

			if (arr != null && arr[0] == name) {
				if (name == "type") {
					return arr[1].indexOf("#") > 0
						? arr[1].split("#")[0]
						: arr[1];
				} else {
					return arr[1];
				}
			}
		}

		return "";
	} else {
		return "";
	}
}

function isJson(obj) {
	var isjson =
		typeof obj == "object" &&
		Object.prototype.toString.call(obj).toLowerCase() ==
			"[object object]" &&
		!obj.length;
	return isjson;
}

function isArray(val) {
	return typeof val == "object" && val.constructor == Array;
}

import h5Api from "./api.js";
const axios = require("axios");
import qs from "qs";

function ajax(type, url, data, noLoad, showStatus = false) {
	if (noLoad != true) {
		setTimeout(r => {
			window.h5ShowLoad && window.h5ShowLoad();
		}, 0);
	}

	if (type.toLowerCase() === "get") {
		url += "?" + qs.stringify(data);

		data = null;
	}

	const options = Object.assign(
		{
			headers: {
				"Content-Type": "application/json;charset=UTF-8",
				Accept: "application/json, text/plain, */*"
			},
			withCredentials: true,
			transformRequest: [
				function(data, headers) {
					if (!headers["Content-Type"]) return JSON.stringify(data);
					switch (headers["Content-Type"].toLowerCase()) {
						case "form": {
							return qs.stringify(data, {
								arrayFormat: "brackets"
							});
						}

						case "multipart/form-data": {
							return data;
						}

						case "application/json": {
							return JSON.stringify(data);
						}

						case "application/json;charset=UTF-8": {
							return JSON.stringify(data);
						}

						default: {
							return JSON.stringify(data);
						}
					}
				}
			],
			checkError: true
		},
		{
			url: url.indexOf("$/") === 0 ? h5Api + url.substring(2) : url,
			method: type,
			data: data
		}
	);

	axios.defaults.withCredentials = false;
	axios.defaults.headers.common["Content-Type"] =
		"application/json;charset=UTF-8";
	// axios.defaults.headers.common['Authorization'] = token;

	let loading;
	if (!options.method) {
		options.method = "GET";
	}

	if (options["isShowLoading"]) {
		options["loading"] = Loading.service({
			fullscreen: true,
			spinner: "el-icon-loading",
			background: "rgba(38, 38, 38, 0.7)"
		});
	}

	if (showStatus) {
		return axios(options)
			.then(({ status, ...res }) => {
				let response = res.data;
				if (status === 200) {
					let { code } = response;
					switch (code) {
						case 200:
							return response;
						default:
							MessageBox.alert({
								message: "服务器错误，请稍后重试~",
								type: "error"
							});
							return response;
					}
				}
			})
			.catch(err => {
				return MessageBox.alert({
					message: "服务器错误，请稍后重试~",
					type: "error"
				});
			})
			.finally(() => {
				if (options["isShowLoading"]) {
					options["loading"].close();
				}

				if (noLoad != true && window.h5CloseLoad) {
					window.h5CloseLoad();
				}
			});
	} else {
		return axios(options)
			.then(res => {
				if (!options["checkError"]) {
					return res.data;
				}

				if (!res.data || res.data.code !== 200) {
					return MessageBox.alert({
						message: res.data.message,
						type: "error"
					});
				}

				return res.data["data"];
				/* eslint-disable */
			})
			.catch(err => {
				return MessageBox.alert({
					message: "服务器错误，请稍后重试~",
					type: "error"
				});
			})
			.finally(() => {
				if (options["isShowLoading"]) {
					options["loading"].close();
				}

				if (noLoad != true && window.h5CloseLoad) {
					window.h5CloseLoad();
				}
			});
	}

	//
	//
	// return new Promise((resolve, reject) => {
	// 	let req = new XMLHttpRequest()
	// 	url = (url.substring(0,2)=='$/'?h5Api+url.substring(2):url)
	// 	if(type=='get'){
	// 		var param = [];
	// 		for(var i in data){
	// 			var t = data[i]
	// 			if(isArray(t)){
	// 				for(var i2 in t){
	// 					var t2 = t[i2];
	// 					if(isJson(t2)){
	// 						for(var i3 in t2){
	// 							var t3 = t2[i3];
	// 							param.push(i+'['+i2+']['+i3+']='+t3);
	// 						}
	// 					}else{
	// 						param.push(i+'['+i2+']='+t2);
	// 					}
	// 				}
	// 			}else{
	// 				param.push(i+'='+t);
	// 			}
	// 		}
	// 		url += '?'+param.join('&')
	// 	}
	//
	// 	req.open(type.toUpperCase(), url,isAysn)
	// 	// req.withCredentials = true // 允许跨域
	// 	req.onreadystatechange = handler
	// 	if(isAysn) req.responseType = 'json'// 规定响应数据格式为 json
	// 	req.setRequestHeader('Content-type', 'application/json;charset=UTF-8')
	// 	req.setRequestHeader('Authorization', userAuthorization)
	// 	if(type=='get'){
	// 		req.send()
	// 	}else{
	// 		req.send(JSON.stringify(data))
	// 	}
	//
	// 	function handler(){
	// 		if(req.readyState!==4) return;
	//
	// 		if(noLoad!=true){
	// 			setTimeout(r=>{ window.h5CloseLoad && window.h5CloseLoad(); },0)
	// 		}
	//
	// 		if(req.status===200){
	// 			if(req.response.code!=200){
	// 				// alert(req.response.message)
	// 				// reject && reject('【后端接口 '+old_url+' '+req.response.code+'错误】'+req.response.message)
	// 				if(req.response.message){
	// 					Message({
	// 						showClose: true,
	// 						message: req.response.message,
	// 						type: 'warning'
	// 					})
	// 				}
	// 				callback && callback(req.response)
	// 			}else{
	// 				resolve && resolve(req.response.data)
	// 				callback && callback(req.response)
	// 			}
	// 			// callback && callback(req.response)
	// 		}else{
	// 			reject && reject(new Error(this.statusText))
	// 		}
	// 	}
	// })
}
function ajax_upload(
	data,
	url = "$/upload/singleFile",
	params = { bookId: "", userId: "" }
) {
	let type = "post";

	setTimeout(r => {
		window.h5ShowLoad && window.h5ShowLoad();
	}, 0);

	return new Promise((resolve, reject) => {
		let req = new XMLHttpRequest();
		url = url.substring(0, 2) == "$/" ? h5Api + url.substring(2) : url;

		var formData = new FormData();
		formData.append("file", data);
		formData.append("bookId", params.bookId);
		formData.append("userId", params.userId);

		req.open(type.toUpperCase(), url);
		// req.withCredentials = true // 允许跨域
		req.onreadystatechange = handler;
		req.responseType = "json"; // 规定响应数据格式为 json
		// req.setRequestHeader('Content-type', 'multipart/form-data')
		// req.setRequestHeader('Content-type', 'application/json;charset=UTF-8')
		req.setRequestHeader("Authorization", userAuthorization);
		req.send(formData);

		function handler() {
			if (req.readyState !== 4) return;

			setTimeout(r => {
				window.h5CloseLoad && window.h5CloseLoad();
			}, 0);
			if (req.status === 200) {
				let res = req.response;
				switch (res.code) {
					case 200:
						return resolve && resolve(req.response.data);
					default:
						Toast(res.message);
						return reject && reject(req.response.data);
				}
			} else {
				reject && reject(new Error(this.statusText));
			}
		}
	});
}

function ajax_download(url, options = {}, fileName) {
	return new Promise((resolve, reject) => {
		// console.log(`${url} 请求数据，参数=>`, JSON.stringify(options));
		axios.defaults.headers["content-type"] =
			"application/json;charset=UTF-8";
		axios({
			method: "get",
			url: url, // 请求地址
			data: options, // 参数
			responseType: "blob" // 表明返回服务器返回的数据类型
		}).then(
			response => {
				resolve(response.data);
				setTimeout(r => {
					window.h5CloseLoad && window.h5CloseLoad();
				}, 0);

				let blob = new Blob([response.data], {
					type: "application/vnd.ms-excel"
				});

				if (window.navigator.msSaveOrOpenBlob) {
					navigator.msSaveBlob(blob, fileName);
				} else {
					var link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.download = fileName;
					link.click();

					//释放内存
					window.URL.revokeObjectURL(link.href);
				}
			},
			err => {
				reject(err);
			}
		);
	});
}

function jumpRecard(isBack) {
	let localStorage = window.localStorage;
	let data = localStorage.getItem("h5jumprecard") || "";
	let arr = [];
	if (data != "") {
		arr = data.split(",");
	}

	if (isBack == true) {
		// 回退
		if (arr.length <= 1) {
			window.location.href = "/";
		} else {
			arr.splice(arr.length - 1, 1);
			localStorage.setItem("h5jumprecard", arr);
			// window.location.href = arr[arr.length-1]
			window.location.replace(arr[arr.length - 1]);
		}
	} else {
		// 前进
		let nowPage = window.location.hash;
		if (arr.length > 0 && arr[arr.length - 1] == nowPage) {
			return;
		}
		arr.push(nowPage);
		localStorage.setItem("h5jumprecard", arr);
	}
}

function jumpRecardEmpty() {
	let nowPage = window.location.hash;
	let localStorage = window.localStorage;
	localStorage.setItem("h5jumprecard", nowPage);
}

function remToPx(rem, int) {
	if (!rem) {
		return 0;
	}
	rem = Number(rem.toString().replace("rem", "") || 0);
	let px = (window.innerWidth / 3.75) * rem;
	if (int == 1 || int == 2) {
		return Number(px.toFixed(int));
	} else {
		return px;
	}
}

function scrollAnimation(obj, y) {
	// var timmer = requestAnimationFrame(function fn(){
	// 	var s = obj.scrollTop
	// 	if(s<y){
	// 		s += (y-s>20?20:y-s)
	// 		obj.scrollTop = s
	// 		timmer = requestAnimationFrame(fn)
	// 	}else if(s>y){
	// 		s -= (s-y>20?20:s-y)
	// 		obj.scrollTop = s
	// 		timmer = requestAnimationFrame(fn)
	// 	}else{
	// 		timmer = null;
	// 	}
	// })
	var nowTop = obj.scrollTop;
	var val = Math.abs(y - nowTop);
	var tak = parseInt(val / 10);
	var init = 0;
	if (nowTop > y) {
		// 向下滚动
	} else if (nowTop < y) {
		// 向上滚动
		var clock = setInterval(r => {
			init++;
			if (init <= tak) {
				obj.scrollTop += 10;
			} else {
				if (obj.scrollTop < y) {
					obj.scrollTop = y;
				}
				clearInterval(clock);
			}
		}, 5);
	}
}

function tabNavTed(type, name, val) {
	let localStorage = window.localStorage;
	if (type == "set") {
		localStorage.setItem("h5nav_" + name, val);
		return true;
	} else {
		let d = localStorage.getItem("h5nav_" + name);
		return d == null || d == "" ? val : d;
	}
}

function checkCanHandle(success) {
	// function getT(h,m,s){
	// 	return (h||0)*60*60 + (m||0)*60 + (s||0)
	// }

	// let date = new Date()
	// let hour = date.getHours()
	// let minute = date.getMinutes()
	// let second = date.getSeconds()
	// let dayStamp = getT(hour,minute,second)

	// if(dayStamp>=getT(8,0,0)&&dayStamp<getT(22,0,0)){
	success && success();
	// }else{
	// 	alert('请在早上8点至晚上10点之间发布/回复问题')
	// }
}

export default {
	localData,
	sessionData,
	cookieData,
	getUrlParam,
	ajax,
	ajax_upload,
	ajax_download,
	jumpRecard,
	jumpRecardEmpty,
	remToPx,
	scrollAnimation,
	tabNavTed,
	checkCanHandle
};



// WEBPACK FOOTER //
// ./src/app/script/public.js